<template>
  <div class="configStatusLevelVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <div class="status-level">

            <!-- <h3 class="mb-10">Penalty Rules
                <span class="c-common-btn--inverse-icon-orange">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </span>
            </h3> -->
            <div class="row">
              <div class="col-md-12 o-no-padding">
                <div class="col-md-6">
                    <h3 class="mb-15">Penalty Rules
                      <span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span>
                    </h3>
                </div>
                <div class="col-md-6 text-right">
                      <ul class="o-filter-area"> 
                        <li></li>                       
                        <!-- <li>
                            <a href="javascript: void(0)" @click="savePenalities()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                        </li> -->
                    </ul>
                </div>
              </div>
            </div>

            <div class="row">
                <!-- <div class="col-md-8 u-margin-20"> -->

                  <div class="table-responsive min-height">
                    <table class="table o-call-table">
                        <thead>
                            <tr>  
                              <th style="width: 40px; max-width: 40px;">Activate</th>
                              <th style="width: 100px; max-width: 100px;">After Click Actions</th>
                              <th style="width: 150px; max-width: 150px;">Rule or Search</th>
                              <th style="width: 200px; max-width: 200px;">System Actions</th>
                              <th style="width: 80px; max-width: 80px;">Action Variable</th>
                              <th style="width: 170px; max-width: 170px;">Notify Sent To Penalty Rules</th>
                              <th style="width: 100px; max-width: 100px;"></th>
                            </tr>
                        </thead>
                        <tbody id="test-body" :loading="loading">
                            <tr v-for="(penalty,key) in penaltyRules" :key="key">
                                <td>
                                    <div>
                                      <div class="toggle-btn mt-10">
                                        <el-switch
                                          style="display: block"
                                          v-model="penalty.state_flag"
                                          active-color="#13ce66"
                                          inactive-color="#dcdfe6"
                                          :active-value="1"
                                          :inactive-value="0"
                                          @change="changeActivateFlag(penalty)"
                                        >
                                        </el-switch>
                                      </div>
                                            
                                    </div>
                                </td>
                                <td>
                                  <el-select v-model="penalty.click_action" filterable placeholder="Select" style="width:100%">
                                    <el-option
                                      v-for="(item,index) in click_actions"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </td>
                                <td>
                                  <el-select v-model="penalty.rules" filterable placeholder="Select" style="width:100%">
                                    <el-option
                                      v-for="(item,index) in rules_or_searches"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </td>                       
                               
                                <td>
                                  <el-select v-model="penalty.system_action" filterable placeholder="Select" style="width:100%" @change="changeActions(penalty)">
                                    <el-option
                                      v-for="(item,index) in system_actions"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </td>

                                <td v-if='penalty.system_action === "move_to_x_list"'>
                                  <select v-model="penalty.x_value" style="width:100%">
                                    <option v-for="(status,index) in employeeStatus" :key="index" :value="status.id"> {{status.name}} </option>
                                  </select>
                                </td>
                                <td v-else-if='penalty.system_action === "raise_seniority_by_x"'>
                                  <el-input v-model="penalty.x_value" placeholder="Seniority"></el-input>
                                </td>
                                <td v-else>
                                  <el-input v-model="penalty.x_value" disabled></el-input>
                                </td>

                                <td>
                                  <!-- <el-input v-model="penalty.note"></el-input> -->
                                  <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 6}"
                                    placeholder="Please input"
                                    v-model="penalty.note">
                                  </el-input>
                                </td>
                                
                              
                                <td class="text-center o-call-icon-allign">
                                  <span v-if="key===penaltyRules.length-1">

                                    <a href="javascript: void(0)" @click="addNewGroup(penalty)" class="table-right-icon table-right-icon--plus">
                                        <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                    </a>
                                    <!-- <a href="javascript: void(0)" @click="addPenaltyRule(penalty)" class="btn-save-penalty-rule">Save</a> -->
                                  </span>
                                  <span v-else>
                                    <a href="javascript: void(0)"  @click="removeGroup(penalty,key)" class="table-right-icon table-right-icon--minus">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                    </a>
                                    <!-- <a href="javascript: void(0)" @click="updatePenaltyRule(penalty)" class="btn-save-penalty-rule">Update</a> -->
                                  </span>
                                  <a href="javascript: void(0)" v-if="penalty&&penalty.id" @click="updatePenaltyRule(penalty)" class="btn-save-penalty-rule">Update</a>
                                  <a href="javascript: void(0)" v-else @click="addPenaltyRule(penalty)" class="btn-save-penalty-rule">Save</a>
                                </td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                  <div id="dummy-div-for-scroll"></div>
                  </div>                    
                <!-- </div> -->
            </div>
        </div>
    </div>

  <!-- </div> -->
</template>
<script>
  import {
      mapGetters,
      mapActions
  } from 'vuex';
  import {
      global
  } from '../../global.js';
  import service from '../../services.js';
    export default {
        data() {
            return {
              loading: false,
              deleteRuleModal: false,
              employeeStatus: [],
              response: null,
              penaltyRules: [],
              penalty_rule: {
                state_flag: 1,
                click_action: "",
                rules: "",
                system_action: "",
                x_value: null,
                note: ""
              },
              addStatus: false,
              deleteStatus: false,
              err_message : 0,
              status_list : [],
              click_actions: [
                 {
                  label: 'Decline',
                  value: 'decline'
                },
                {
                  label: 'CallOut',
                  value: 'callout'
                },
                {
                  label: 'Late',
                  value: 'late_arrival'
                },
                 {
                  label: 'NoShow',
                  value: 'no_show'
                },
               
                {
                  label: 'Passed', 
                  value: 'pass'
                }, 
                
                {
                  label: 'SentHome',
                  value: 'sent_home'
                },
               
                {
                  label: 'Time Out',
                  value: 'time_out'
                }
               
              ],
              rules_or_searches: [
                {
                  label: '3 Consecutive Declines',
                  value: '3_consecutive_declines'
                },
                {
                  label: '2nd Pass For Same Day',
                  value: '2_pass_within_24_hours'
                },
                {
                  label: '3rd late arrival in 7 days',
                  value: '3_late_within_7_days'
                },
                {
                  label: '3 Consecutive Timeouts',
                  value: '3_consecutive_timeout'
                }
              ],
              system_actions: [
                {
                  label: 'Move to different status group',
                  value: 'move_to_x_list'
                }, 
                // {
                //   label: 'Move to a Client List X',
                //   value: 'move_to_x_list'
                // }, 
                {
                  label: 'Increases Employee Seniority Value',
                  value: 'raise_seniority_by_x'
                },
                // {
                //   label: 'Raise Seniority by X',
                //   value: 'raise_seniority_by_x'
                // },
                { 
                  label: 'Place on 7 day Vacation',
                  value: 'place_on_7_days_vacation'
                },
                { 
                  label: 'Convert 2nd Pass to Decline',
                  value: 'convert_second_pass_to_decline'
                },

              ]
            }
        },
        computed: {
          ...mapGetters({
            userToken: 'userToken',
            userRole: 'userRole',
            userID: 'userID',
            userClientID: "userClientID"
          }),
        },
        methods: {
          async getEmployeeStatus(){
            await service.get("employee/employee_status_lite", {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID,
            }).
            then((res) => {
                this.employeeStatus = res.data.result;
                // console.log(res.data.result);
                this.employeeStatus.sort(function(a, b) {

                    if (Number(a.priority) < Number(b.priority)) return -1;
                    if (Number(a.priority) > Number(b.priority)) return 1;
                    return 0;
                });
                // this.selectStatus=this.employeeStatus[0].id;
                // this.$Progress.finish();
                // this.loading = false;
                // this.getEmployeeWithStatusAndSkill();
            }).catch((err) => {
                console.log(err);
                // this.$Progress.finish();
                // this.loading = false;
            });
          },
          async fetchPenaltyRules() {
            // console.log("fetch penalties");
            await service.get('client/' + this.userClientID + '/getClientPenaltyActions', {
                'Authorization': this.userToken
            })
            .then((res) => {
              this.penaltyRules = res.data.result;
              
            }).catch((err) => {
                console.log(err);
            });
          },
          async addNewGroup(penalty) {
            var temp = {
              state_flag: 1,
              click_action: "",
              rules: "",
              system_action: "",
              x_value:null,
              note: ""
            };
            this.penaltyRules.push(temp);
            setTimeout(function(){ 
                document.getElementById('dummy-div-for-scroll').scrollIntoView({ behavior: 'smooth' });            
              }, 10);
          },
          async removeGroup(penalty,key) {            
            // this.deleteRuleModal = true;
            this.$confirm('Do you want to delete this rule?', 'Warning', {
              confirmButtonText: 'Yes',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(async() => {
              await  this.deleteRules(penalty,key);
            }).catch(() => {
              this.$message({
                type: 'info',
                message: 'Delete canceled'
              });          
            });
            
          },
          async deleteRules(penalty,key) {
            // console.log(penalty);
            let id=null;
            if(penalty&&penalty.id) {
              id = penalty.id;
           
              await service.del(`client/deletePenaltyAction/${id}`, 
                { 'Authorization': this.userToken })
                .then(async(res) => {
                    this.response = res.data;
                    this.loading = true;
                    await this.fetchPenaltyRules();
                    this.loading = false;
                    this.$message({
                      type: 'success',
                      message: 'Delete completed'
                    });
                }).catch((err) => {
                    console.log(err);
                });

              
            }else {
              this.penaltyRules.splice(key, 1);
            }
          },

          changeActions(penalty) {
            penalty.x_value = null;
          },
          checkAddGroup() {
            if ((this.penaltyRules)&&(!this.penaltyRules.length)) {
              this.penaltyRules.push(this.penalty_rule);     
            }
          },

          async changeActivateFlag(penalty) {
            if(penalty.id) {
              await this.updatePenaltyRule(penalty);
            }
          },

          async addPenaltyRule(penalty) {
            let params = {
              client_id: this.userClientID,
              // state_flag: penalty.state_flag,
              click_action: penalty.click_action,
              rules: penalty.rules, 
              system_action: penalty.system_action, 
              x_value:penalty.x_value,
              note: penalty.note
            }
           
            this.response = null;
            await service.post('client/addPenaltyAction',  params, 
              { 'Authorization': this.userToken })
              .then(async(res) => {
                  this.response = res.data;
                  this.loading = true;
                  this.$message({
                      type: 'success',
                      message: 'Penality Rule Added Successfully'
                  });
                  await this.fetchPenaltyRules();
                  this.loading = false;
              }).catch((err) => {
                  console.log(err);
              });
          },
          async updatePenaltyRule(penalty) {
            let params = {
              state_flag: penalty.state_flag,
              click_action: penalty.click_action,
              rules: penalty.rules, 
              system_action: penalty.system_action, 
              x_value:penalty.x_value,
              note: penalty.note
            }
           
            this.response = null;
            await service.put(`client/updatePenaltyAction/${penalty.id}`,  params, 
              { 'Authorization': this.userToken })
              .then(async(res) => {
                  this.response = res.data;
                  this.loading = true;
                  this.$message({
                      type: 'success',
                      message: 'Penality Rule Updated Successfully'
                  });
                  await this.fetchPenaltyRules();
                  this.loading = false;
              }).catch((err) => {
                  console.log(err);
              });
          },

        },

        async mounted()
        {
          this.loading = true;
          await this.fetchPenaltyRules();
          await this.getEmployeeStatus();
          this.loading = false;
          this.checkAddGroup();
        }
    }

</script>
<style scoped>
#dummy-div-for-scroll {
    height: 50px;
}

.btn-save-penalty-rule {
  background: #1AB677;
  padding: 10px;
  color: #ffffff;
  border-radius: 5px;
}
.mb-15{
  margin-bottom: 15px;
}
.min-height{
  min-height: 20px;
}
.mt-10{
  margin-top: 10px;
}
</style>
